import React, { CSSProperties } from 'react';
import ConcussionLogo from 'img/concussionrx-logo-new.png';

/**
 * The concussionRX logo with text
 *
 * TODO: Refactor this to a separate module
 */

export function ConcussionRXLogo(props: { style?: CSSProperties }) {
  return <img style={{ width: '100%', ...props.style }} src={ConcussionLogo} />;
}
